module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "echart",
    staticStyle: {
      "width": "100%",
      "height": "500px",
      "display": "flex",
      "flex-wrap": "nowrap"
    }
  }, [_c('div', {
    ref: "myEchart",
    style: ({
      height: _vm.height,
      width: _vm.width
    })
  }), _vm._v(" "), _c('div', {
    ref: "myEchart2",
    style: ({
      height: _vm.height,
      width: _vm.width
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "echart",
    staticStyle: {
      "width": "80%",
      "height": "400px",
      "padding-bottom": "300px",
      "margin-top": "30px"
    }
  }, [_c('div', {
    ref: "myEchart3",
    staticStyle: {
      "margin-left": "8%",
      "width": "80%"
    },
    style: ({
      height: _vm.height
    })
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06a8fe30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/patient/dashboard.vue
// module id = 993
// module chunks = 2